import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import WorkoutScheduleTable from "../components/WorkoutScheduleTable";
import { useLanguage } from "../i18n/LanguageContext";
import apiClient from "../api/apiClient";
import { useAuth } from "../auth/AuthContext";

const MySchedulePage = () => {
  const { t } = useLanguage();
  const { user } = useAuth();
  const [plan, setPlan] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    setLoading(true);
    apiClient.get("/my-schedule")
      .then(({ data }) => setPlan(data.plan ?? null))
      .catch(() => setPlan(null))
      .finally(() => setLoading(false));
  }, [user]);

  const handlePlayVideo = async (video, onReady) => {
    try {
      const response = await apiClient.get(`/videos/${video.slug}`);
      const embedUrl = response.data.data?.embed_url;
      if (embedUrl) onReady(embedUrl, video.title);
    } catch {
      // Access errors remain handled by the protected video endpoint.
    }
  };

  const handleSaveExerciseLog = async (exercise, payload) => {
    const response = await apiClient.post(`/my-schedule/exercises/${exercise.assignment_id}/log`, payload);
    const updatedLog = response.data.log;
    setPlan((current) => {
      if (!current) return current;
      const days = Object.fromEntries(Object.entries(current.days || {}).map(([day, videos]) => [
        day, videos.map((video) => video.assignment_id === exercise.assignment_id ? { ...video, user_log: updatedLog } : video),
      ]));
      return { ...current, days };
    });
    return updatedLog;
  };

  return <div className="page-content hpa-program-page">
    <div className="hpa-program-shell"><div className="container">
      {!user && <div className="hpa-program-auth">
        <span className="hpa-program-empty__icon"><i className="fa-solid fa-lock" /></span>
        <h2>{t("Login Required")}</h2><p>{t("Please log in to view your personalised workout schedule.")}</p>
        <Link to="/login" className="hpa-program-primary-btn">{t("Login")}</Link>
      </div>}

      {user && loading && <div className="hpa-program-loading"><div className="spinner-border text-danger" role="status" />
        <p>{t("Loading your schedule...")}</p></div>}

      {user && !loading && <>
        <header className="hpa-program-heading"><div><span className="hpa-program-eyebrow">{t("Personalised training")}</span>
          <h1>{t("My Program")}</h1></div><p>{t("Your coach-built week, exercise targets, and progress in one focused view.")}</p></header>
        <WorkoutScheduleTable plan={plan} onPlayVideo={handlePlayVideo} onSaveExerciseLog={handleSaveExerciseLog} />
      </>}
    </div></div>
  </div>;
};

export default MySchedulePage;
